import moment from "moment";

const prependZero = (time) => {
  if (time < 10) {
    return `0${time}`;
  }
  return time;
};

const getRemainingTime = (date) => {
  if (date) {
    const expirationTime = moment(date);
    const now = new moment();
  
    const diff = expirationTime.diff(now);
    const passed = diff <= 0;
  
    if (!passed) {
      const seconds = Math.floor(diff / 1000);
      const minutes = Math.floor(seconds / 60);

      return `${prependZero(minutes)}:${prependZero(seconds % 60)}`;
    }
  }
};

export const OtpMixin = {
  methods: {
    clearExpirationInterval() {
      if (this.expirationIntervalId) clearInterval(this.expirationIntervalId);
    },
    clearResendCooldownInterval() {
      if (this.resendCooldownIntervalId) clearInterval(this.resendCooldownIntervalId);
    },
    setExpirationText() {
      const remainingTime = getRemainingTime(this.otpExpiresAt);
      if (remainingTime) {
        this.isOtpExpired = false;
        this.expirationText = remainingTime;
      } else {
        this.isOtpExpired = true;
        this.clearExpirationInterval();
        this.expirationText = "";
      }
    },
    setResendCooldownText() {
      const remainingTime = getRemainingTime(this.nextResend);
      if (remainingTime) {
        this.canResend = false;
        this.resendCooldownText = remainingTime;
      } else {
        this.canResend = true;
        this.resendCooldownText = "";
        this.clearResendCooldownInterval();
      }
    },
    updateExpirationTimer(otpExpiresAt) {
      this.otpExpiresAt = otpExpiresAt;
      this.clearExpirationInterval();
      this.setExpirationText();
      this.expirationIntervalId = setInterval(() => this.setExpirationText(), 1000);
    },
    updateResendCooldownTimer(nextResend) {
      this.nextResend = nextResend;
      this.clearResendCooldownInterval();
      this.setResendCooldownText();
      this.resendCooldownIntervalId = setInterval(() => this.setResendCooldownText(), 1000);
    },
  },
  data() {
    return {
      resendCooldownIntervalId: null,
      resendCooldownText: "",
      canResend: false,
      nextResend: null,
      expirationIntervalId: null,
      expirationText: "",
      otpExpiresAt: null,
      isOtpExpired: false
    };
  },
  beforeDestroy() {
    this.clearResendCooldownInterval();
    this.clearExpirationInterval();
  },
};
